/* import __COLOCATED_TEMPLATE__ from './pix-app-layout.hbs.js'; */
var _class, _descriptor, _PixAppLayout_brand;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { VARIANTS } from '@1024pix/pix-ui/helpers/variants';
import { warn } from '@ember/debug';
import { service } from '@ember/service';
import Component from '@glimmer/component';
let PixAppLayout = (_class = (_PixAppLayout_brand = /*#__PURE__*/new WeakSet(), class PixAppLayout extends Component {
  constructor(...args) {
    super(...args);
    _classPrivateMethodInitSpec(this, _PixAppLayout_brand);
    _initializerDefineProperty(this, "elementHelper", _descriptor, this);
    _defineProperty(this, "handleMarginContainerNavigation", element => {
      _assertClassBrand(_PixAppLayout_brand, this, _computeMarginTopElement).call(this, element);
    });
    this.elementHelper.waitForElement('pix-layout-banner-container').then(elementList => {
      _assertClassBrand(_PixAppLayout_brand, this, _computeMarginTopElement).call(this, elementList);
    });
  }
  get variant() {
    const value = this.args.variant ?? 'primary';
    warn(`PixAppLayout: @variant "${value}" should be ${VARIANTS.join(', ')}`, VARIANTS.includes(value), {
      id: 'pix-ui.pix-app-layout.variant.not-valid'
    });
    return value;
  }
  get classNames() {
    return ['pix-app-layout', `pix-app-layout--${this.variant}`].join(' ');
  }
}), _descriptor = _applyDecoratedDescriptor(_class.prototype, "elementHelper", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
function _computeMarginTopElement(bannerContainer) {
  const baseFontRemRatio = Number(getComputedStyle(document.querySelector('html')).fontSize.match(/\d+(\.\d+)?/)[0]);
  const bannerHeight = bannerContainer.getBoundingClientRect().height;
  const top = bannerHeight / baseFontRemRatio;
  const layoutElement = document.querySelector('.pix-app-layout');
  layoutElement.style.setProperty('--pix-app-layout-top', `${top}rem`);
}
export { PixAppLayout as default };